import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tipoPresupuestoImporterSelectors = importerSelectors(
  'tipoPresupuesto.importer',
);

export default tipoPresupuestoImporterSelectors;
